export default [    //围栏
  {
    path: "/sosrdingList",   //围栏列表
    name: 'sosrdingList',
    component: () => import("@/views/sos/sosrdingList.vue")
  },
  {
    path: "/sosDetail",   //围栏详情
    name: 'sosDetail',
    component: () => import("@/views/sos/sosDetail.vue")
  }
]
